 <template>
  <div class="container">
    <!-- 主体内容 -->
    <div class="main-content">
      <div style=" background: #f5f5f5; height: 8px;width: 100%;"></div>
      <div class="header" style="font-size: 16px;font-weight: 700;">
        <p style="margin-left: 15px; color: #737A84;">
          桌位号 ： {{ deskCode.code }}
        </p>
         <div
            v-if="payMethodType == 1"
          style="margin-left: 15px; color: #737A84; flex: 1; display: flex"
        >
          <p style="width: 90px;font-size: 16px;">就餐人数 ：</p>
          <input
            style="
              border: 0px solid transparent;
              width: 50px;"
            v-model="orderPeople"
          />
        </div>
        <div
          v-if="payMethodType == 2"
          style="margin-left: 15px; color:#737A84; flex: 1; display: flex;margin-left: 40px;"
        >
          <p style="font-size: 16px;width:auto;">手牌号 ：</p>
           <!-- <div v-if="KeyBindComponent===0" style="flex: 1;display: flex;align-items: center;">
              <p style="border: 0px solid transparent;width:80px;" >{{deskCode.cardCode}}</p>
            <img src="@/assets/order/1@2x(3).png" class="scan-key-code" @click="bindingHandNumber"/>
           </div> -->
          <input 
            style="
              border: 0px solid transparent;
              width: 100px;
              margin-right: 10px;"
            v-model="deskCode.cardCode"
          />
        </div>
        <img
          class="header-right-img"
          style="margin-right: 20px"
          :src="require('@/assets/order/1@2x(2).png')"
          @click="deleteAllGoods"
        />
      </div>
      <div class="content">
        <!-- 右侧菜品列表 -->
        <div class="menu-list">
          <div class="cart_goods_con" style="background-color:  #F6F6F6;">
            <div style="display: flex; flex-direction: column;background-color: white;border-bottom-right-radius: 12px;border-bottom-left-radius: 12px;" >
              <div
                v-for="(group, index) in allCarGoodsArr"
                :key="index"
                style="margin-left: 10px; margin-right: 10px"
              >
                <p
                  style="
                    color: #737a84;
                    padding-top: 10px;
                    font-size: 16px;
                    padding-bottom: 10px;
                  "
                >
                  {{ group.GoodsCatalogName }}
                </p>
                <div
                  v-for="(item, j) in group.children"
                  :key="j"
                  style="margin-top: 5px; height: auto"
                >
                  <div style="display: flex;">
                    <img
                      v-if="item.PicUrl && item.PicUrl.length > 0"
                      :src="item.PicUrl"
                      style="width: 102px; height: 50px; border-radius: 10px"/>
                    <img
                      v-else
                      :src="require('@/assets/order/1@2x(20).png')"
                      style="width: 102px; height: 50px; border-radius: 10px"
                    />
                    <div style="flex: 1">
                      <div class="goodsname-item" style="font-size: 14px;color: #737A84;font-weight: 700">{{ item.GoodsName }}</div>
                      <div
                        class="goodsname-item"
                        style="display: flex; height: 40px;"
                      >
                        <div style="width: auto;font-size: 14px;font-weight: 700">{{ item.Price }}</div>
                        <div class="goods-Unit" style="font-size: 12px;">
                          元 / {{ item.Unit ? item.Unit : "份" }}
                        </div>
                        <div style="flex: 1"></div>
                        <img
                          v-if="item.num > 0"
                          :src="require('@/assets/order/1@2x(8).png')"
                          class="img-add"
                          @click="updateNumberLess(item, index, j)"
                        />
                        <div v-if="item.num > 0" class="goods-num" style="font-size: 16px;font-weight: 700" >
                          {{ item.num }}
                        </div>
                        <img
                          :src="require('@/assets/order/1@2x(9).png')"
                          class="img-add-right"
                          @click="updateNumberAdd(item, index, j)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
             <div class="remark-class" style="height: 80px;border-radius: 12px;margin-top: 8px;">
            <p
            style="
              width: 100%;
              height: auto;
              color: #737A84;
              font-size: 16px;
              padding-top: 8px;
              padding-left: 25px; ">
            备注 
          </p>
          <input
            class="input-class"
            style="margin-left: 25px;font-size: 12px;color: #B7BDC3;"
            placeholder="如果您有什么其他要求请留言，我们会尽量满"
          />
        </div>
          </div>
        </div>
       
      </div>
    </div>
    <!-- 底部订单栏 -->
    <div class="order-bar">
      <div style="flex: 1">
        <div
          style="
            color: #737A84;
            font-size: 18px;
            display: flex;
            margin-top: 10px;
            height: 20px;
            font-weight: 700
          "
        >
          <p style="font-size: 14px; font-weight: normal;padding-right: 5px;">应付:</p>
          {{ allMoney.toFixed(2) }}
          <p style="font-size: 14px; font-weight: normal; margin-left: 5px">
            元
          </p>
        </div>
        <p style="color: #737a84; font-size: 12px;color: #B7BDC3;">共计{{ allCount }}道菜</p>
      </div>

      <div class="confirm-btn" :loading="isSubmitLoading" style="font-size: 16px;" @click="submitOrder">
        现在下单
      </div>
    </div>
    <!-- 这是购物车删除按钮 -->
    <van-overlay :show="showBuyCardDeletedModal" z-index="999"
     :style="{
      background: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)'
    }">
      <div class="overlay_con" style="margin-left: 10px; margin-right: 10px">
        <div class="overlay_con_content">
          <p style="text-align: center; height: 30px"></p>
          <p class="overlay_con_p">挑了好久呢，全部都不要了吗？～</p>
          <div
            style="
              margin-left: 40px;
              margin-right: 40px;
              margin-top: 30px;
              display: flex;
            "
          >
            <van-button
              color="#E1EDDE"
              block
              round
              class="cancel-custom-button"
              @click="deleteAllGoodsForSeleted"
              >狠心删除</van-button
            >
            <div style="width: 40px" />
            <van-button
              color="#E1EDDE"
              block
              round
              class="custom-button"
              @click="showBuyCardDeletedModal = false"
              >继续保留</van-button
            >
          </div>
          <div style="height: 30px" />
        </div>
      </div>
    </van-overlay>

     <!-- 发布成功弹窗 -->
    <van-overlay :show="showSubmitSuccModal" z-index="999"
     :style="{
      background: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)'
    }">
      <div class="overlay_con" style="margin-left: 10px; margin-right: 10px">
        <div class="overlay_con_content">
           <div style="display: flex;">
            <div style="flex: 1;" />
            <img style="width: 82px; height: 100px;margin-top: 36px;"  :src="submitOrderImage">
             <div style="flex: 1;" />
           </div>
           <p v-if="submitOrderImageTitle==='下单成功～'" style="width: 100%;height: 20px;font-size: 16px;color: #849D80;line-height: 20px;text-align: center;margin-top: 24px;">{{submitOrderImageTitle}}</p>
           <p  v-else style="width: 100%;height: 20px;font-size: 16px;color: #FF7D66;line-height: 20px;text-align: center;margin-top: 24px;">{{submitOrderImageTitle}}</p>

          <div
            style="
              margin-left: 8px;
              margin-right: 8px;
              margin-top: 44px;
              display: flex;"
          >
            <van-button
              color="#E1EDDE"
              block
              round
              class="cancel-custom-button"
              @click="showSubmitSuccModal = false"
              >知道了</van-button
            >
            <div style="width: 40px" />
            <van-button
              color="#E1EDDE"
              block
              round
              class="custom-button"
               @click="SubmitSuccDailogBack"
              >{{mSubmitSuccSureBtn}}</van-button
            >
          </div>
          <div style="height: 30px" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { handleSessionStorage } from "@/utils";
import { handleLocalStorage, handleScanCode } from "@/utils";
import { Dialog } from "vant";
import {
  getDiningRoomList,
  getFoodList,
  getSetmealFoodInfo,
} from "@/api/foodOrder";
import { submitFoodOrder } from "@/api/foodOrder";
export default {
  name: "MicropointCurrentConsume",
  data() {
    return {
      remarkString: "",
      showBuyCardDeletedModal: false,
      showSubmitSuccModal: false,
      mSubmitSuccSureBtn: "继续加菜",
      submitOrderImageTitle: "下单成功～",
      submitOrderImage: require("@/assets/order/order_submit_succ.png"),
      searchInputVaule: "",
      deskCode: {},
      teamId: "",
      diningRoomId: "",
      saasCode: "",
      isSureVpn: false,
      allMoney: 0.0,
      allCount: 0,
      vpnInfo: {},
      allCarGoodsArr: [],
      seletedGoodMap: {},
      orderPeople: 1,
      payMethodType: 2,
      KeyBindComponent: 0,
      preOrderId: undefined,
      EnableTeamOrder: false,
      isSubmitLoading: false,
    };
  },
  created() {
    this.seletedGoodMap = handleSessionStorage.get("NewGoods");
    this.deskCode = handleSessionStorage.get("deskCode");
    this.teamId = handleSessionStorage.get("teamId");
    this.saasCode = this.$route.query.saasCode;
    this.isSureVpn = handleSessionStorage.get("isSureVpn");
    const vpnStorage = handleSessionStorage.get("vpnInfo");
    this.vpnInfo = vpnStorage;
    this.diningRoomId = handleSessionStorage.get("diningRoomId");
    const deskObj = handleSessionStorage.get("deskCode");
    this.orderPeople = deskObj.PersonNum ? deskObj.PersonNum : 1;
    this.payMethodType = deskObj.PayMode ? deskObj.PayMode : 1;
    (this.KeyBindComponent = this.vpnInfo.KeyBindComponent
      ? this.vpnInfo.KeyBindComponent
      : 0),
      (this.EnableTeamOrder = handleSessionStorage.get("EnableTeamOrder"));
    this.queryShopingCarData();
    this.queyDiningRoomList();
    if (this.EnableTeamOrder && this.isSureVpn) {
      this.handleInitConnet();
    }
  },

  methods: {
    bindingHandNumber() {
      // 调起微信扫码，并执行成功函数
      const NeedResultType = 1;
      handleScanCode({ needResult: NeedResultType }, this.handleScanSuccess);
    },
    handleScanSuccess(res) {
      if (res) {
        const result = res + "";
        const _pString = result.split("?p=")[1];
        this.$router.replace({
          name: "takeNumberResult",
          query: {
            action: "takeorder",
            fromPage: "NewMicropoint",
            isFromMicropoint: false,
            backUrl: "MicropointCurrentConsume",
            vpncode: params.vpncode,
            p: _pString,
          },
        });
      }
    },
    submitOrder() {
      let foodsList = [];
      this.allCarGoodsArr.forEach((group) => {
        group.children.forEach((item) => {
          let RemarkStr = item.remark || "";
          RemarkStr = item.CustomRemark
            ? RemarkStr + " " + item.CustomRemark
            : RemarkStr;
          let newItem = {
            ProductId: item.Id,
            ProductName: item.GoodsName,
            ProductType: item.GoodsCatalog,
            Quantity: item.num,
            Remark: RemarkStr,
            GoodsServiceId: item.IsServiceId,
          };
          if (item.IsMultiSpecific) {
            newItem.SpecificId = item.SpecificId;
            newItem.Specification = item.Name;
          }
          if (item.MethodName) {
            newItem.DoWay = item.MethodName;
          }
          if (item.TasteNameObj && Object.keys(item.TasteNameObj).length > 0) {
            newItem.Taste = Object.keys(item.TasteNameObj).sort().join(",");
          }
          if (item.IsServiceId == 6) {
            let subArr = [];
            for (var key in item.selectGoodsObj) {
              const sItem = item.selectGoodsObj[key];
              sItem.forEach((gItem) => {
                subArr.push({
                  GoodsId: gItem.GoodsId,
                  GoodsName: gItem.GoodsName,
                  GoodsServiceId: 6,
                  NumberCount: gItem.num,
                  PackageMealGroupId: key,
                });
              });
            }
            newItem.SubMealDTOs = subArr;
          }
          foodsList.push(newItem);
        });
      });
      if (this.isSubmitLoading == true) {
        return;
      }
      this.isSubmitLoading = true;
      const requestData = {
        DinnerRoomId: this.diningRoomId,
        TeamId: this.EnableTeamOrder && this.isSureVpn ? this.teamId : null,
        VpnId: this.vpnInfo.id,
        PayType: this.payMethodType,
        KeyCode: this.deskCode.cardCode,
        CheckinId: this.deskCode.checkinId,
        TableCode: this.deskCode.code,
        PersonNum: this.orderPeople,
        TotalAmount: this.allMoney.toFixed(2),
        Remark: this.remarkString ? this.remarkString + "；" : "",
        Items: foodsList,
        CancelOrderId: this.preOrderId,
      };
      submitFoodOrder(requestData)
        .then((res) => {
          this.preOrderId = undefined;
          this.isSubmitLoading = false;
          if (res.UnPaidOrderId) {
            //当前还有未支付订单
            Dialog.confirm({
              title: "提示",
              message:
                "您有未支付的自助点单订单，您可以选择取消未支付的订单，或者继续支付上一个订单",
              cancelButtonText: "取消订单",
              confirmButtonText: "继续支付",
            })
              .then(() => {
                // on confirm
                this.$router.push({
                  name: "MicropointHistoryConsume",
                });
              })
              .catch(() => {
                // on cancel
                this.preOrderId = res.UnPaidOrderId;
                this.submitOrder();
              });
            return;
          }
          this.deleteAllGoodsForSeleted();
          if (this.payMethodType == 1) {
            //在线支付
            this.$router.replace({
              name: "PayList",
              query: { id: res.OrderId, fromPage: "food" },
            });
          } else {
            const deskObj = handleSessionStorage.get("deskCode");
            this.mSubmitSuccSureBtn = "继续加菜";
            this.submitOrderImageTitle = "下单成功～";
            this.submitOrderImage = require("@/assets/order/order_submit_succ.png");
            this.showSubmitSuccModal = true;
            // handleSessionStorage.set("deskCode", {
            //   ...deskObj,
            //   cardCode: this.deskCode.cardCode,
            //   PayMode: this.payMethodType
            // });
            // this.$router.replace("PlaceOrderSuccess");
          }
          handleSessionStorage.set("NewGoods", {});
        })
        .catch(() => {
          this.mSubmitSuccSureBtn = "重新下单";
          this.submitOrderImageTitle = "下单失败～";
          this.submitOrderImage = require("@/assets/order/order_submit_error.png");
          this.showSubmitSuccModal = true;
          this.isSubmitLoading = false;
        });
    },
    queryShopingCarData() {
      this.allCarGoodsArr = [];
      const list = Object.values(this.seletedGoodMap);
      const typeArray = [];
      list.forEach((mode) => {
        if (!typeArray.includes(mode.GoodsCatalog)) {
          typeArray.push(mode.GoodsCatalog);
        }
      });
      typeArray.forEach((GoodsCatalog) => {
        const children = list.filter(
          (mode) => GoodsCatalog == mode.GoodsCatalog
        );
        this.allCarGoodsArr.push({
          GoodsCatalogName: GoodsCatalog,
          children: children,
        });
      });
      this.updateMoneyCount();
    },

    deleteAllGoods() {
      this.showBuyCardDeletedModal = true;
    },
    SubmitSuccDailogBack() {
      this.showSubmitSuccModal = false;
      if (this.mSubmitSuccSureBtn.includes("继续加菜")) {
        this.$router.back();
      } else {
      }
    },
    /**删除所有已选商品*/
    deleteAllGoodsForSeleted() {
      this.showBuyCardDeletedModal = false;
      this.seletedGoodMap = {};
      this.allCarGoodsArr = [];
      this.updateMoneyCount();
    },
    updateMoneyCount() {
      this.allMoney = 0.0;
      this.allCount = 0;
      this.allCarGoodsArr.forEach((childrenItem) => {
        childrenItem.children.forEach((item) => {
          this.allMoney = this.allMoney + item.num * item.Price;
          this.allCount = this.allCount + item.num;
        });
      });
      handleSessionStorage.set("NewGoods", this.seletedGoodMap);
    },
    /**商品加号*/
    updateNumberAdd(item, index, j) {
      item.num = item.num + (item.MinBuyCount ? item.MinBuyCount : 1);
      const childrenItem = this.allCarGoodsArr[index];
      childrenItem.children[j] = item;
      this.allCarGoodsArr[index] = childrenItem;
      this.$set(this.seletedGoodMap, item.GoodsCode, item);
      this.updateMoneyCount();
    },
    /**点击商品减号*/
    updateNumberLess(item, index, j) {
      if (item.num <= 1) {
        const childrenItem = this.allCarGoodsArr[index];
        childrenItem.children = childrenItem.children.filter(
          (mode) => mode.GoodsCode != item.GoodsCode
        );
        this.allCarGoodsArr[index] = childrenItem;
        this.$delete(this.seletedGoodMap, item.GoodsCode);
        if (childrenItem.children.length == 0) {
          this.allCarGoodsArr = this.allCarGoodsArr.filter(
            (group) => group.GoodsCatalogName != childrenItem.GoodsCatalogName
          );
        }
      } else {
        item.num = item.num - (item.MinBuyCount ? item.MinBuyCount : 1);
        const childrenItem = this.allCarGoodsArr[index];
        childrenItem.children[index] = item;
        this.allCarGoodsArr[index] = childrenItem;
        this.$set(this.seletedGoodMap, item.GoodsCode, item);
      }
      this.updateMoneyCount();
    },

    handleInitConnet() {
      // 建立连接
      initConnect();
      if (this.$store.state.pointConnet) {
        handleSendMessage("SendGoodsList", {
          TeamId: this.teamId,
          duration: this.vpnInfo.OrderTeamDuration,
        });
      }
      EventBus.$on("getMessage", (data) => {
        // 接收服务端发送来的消息
        console.log("点单页成功收到了-------------", data);
        const index = this.goodsList.findIndex(data.GoodsCode);
        if (data.Quantity > 0 && index != -1) {
          //   //某商品增加了
          data.num = data.Quantity;
          this.updateNumberAdd(data, data.Quantity);
        } else {
          this.updateNumberLess(data, -data.Quantity);
        }
      });
      EventBus.$on("getGroupGoodsList", (data, isClear) => {
        // 接收服务端发送来的消息
        console.log("点单页初始列表收到了-------------", data);
        // 初始化购物车商品
        this.$store.commit("shopCart/initCardList", data);
        if (isClear) {
          this.deleteAllGoodsForSeleted();
        } else {
        }
      });
    },

    queyDiningRoomList() {
      getDiningRoomList({ vpnId: this.vpnInfo.id })
        .then((res) => {
          const item = res.find((mode) => mode.Id == this.diningRoomId);
          if (item == undefined) {
            this.diningRoomId = res[0].Id;
            handleSessionStorage.set("diningRoomId", res[0].Id);
            this.payMethodType = res[0].PayMode;
          } else {
            this.payMethodType = item.PayMode;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  margin-top: 1%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.header {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  width: 100%;
  height: 60px;
  color: #737a84;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #f1f1f1;
  backdrop-filter: blur(9px);
}

.header-right-img {
  width: 40px;
  height: 40px;
}
.main-content {
  width: 100%;
  flex: 1;
}
.content {
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  width: 100%;
  /* height: 100%; */
}
.menu-list {
  width: 100%;
   background: #f5f5f5;
  overflow-y: auto;
  height: calc(100vh - 250px);
}
.menu-item {
  display: flex;
  height: auto;
  border: 1px solid #eeeded;
  border-radius: 4px;
  margin-bottom: 20px;
}
.goodsname-item {
  text-align: left;
  color: #555c67;
  height: 50px;
  margin-left: 20px;
  margin-right: 20px;
  width: 100%;
  font-weight: 700;
  text-align: left;
  color: #737a84;
  line-height: 60px;
}
.goods-PicUrl {
  height: 280px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.goods-Unit {
  width: auto;
  color: #97a0a9;
  margin-left: 6px;
  font-size: 23px;
}
.goods-num {
  min-width: 50px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #737a84;
  font-size: 16px;
}
.img-add {
  width: 40px;
  height: 40px;
}
.img-add-right {
  width: 40px;
  height: 40px;
  margin-right: 26px;
}
.order-bar {
  @include fixed-bottom-box-con;
  height: 100px;
  align-items: center;
  line-height: 100px;
  display: flex;
  margin-bottom: 0px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0px 2px 6px 0px rgba(164, 193, 158, 0.4);
  backdrop-filter: blur(2px);
  background-color: #fff; /* 光晕的中心颜色 */
}

.confirm-btn {
  background-color: RGBA(234, 242, 232, 1);
  height: 80px;
  color: #849d80;
  line-height: 80px;
  border-radius: 40px;
  font-weight: 700;
  width: 320px;
  text-align: center;
}

.red-good-num {
  width: auto;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  background-color: red;
  border-radius: 40px;
  color: white;
  text-align: center;
  font-size: 25px;
}

.overlay_con_content {
  width: 100%;
  margin-left: 10px;
  margin-right: 10px;
  background-color: white;
  border-radius: 10px;
  align-items: center;
  color: #737a84;
  font-size: 37px;
}
.overlay_con_p {
  text-align: center;
  margin-top: 40px;
  height: 48px;
  line-height: 48px;
  color: #737a84;
  font-size: 34px;
}
.custom-button {
  color: #849d80 !important;
  font-weight: bold;
}
.cancel-custom-button {
  color: #97a0a9 !important;
  font-weight: bold;
  background: white !important;
  border: 1px solid #eaeaea;
}
.remark-class {
  margin-top: 30px;
  background-color: white;
  width: 100%;
  border-radius: 12px;
  backdrop-filter: blur(9px);
  color: #737a84;
}
.input-class {
  height: 50px;
  margin-left: 5%;
  width: 90%;
  font-size: 12px;
  border: 0px solid transparent;
}
.input-class::placeholder {
  color: #b7bdc3;
}
.scan-key-code {
  height: 30px;
  width: 30px;
  object-fit: cover;
}
</style>